import React from "react";
import profileCheckIcon from "../../assets/icons/profileCheck.svg";
import profileCrossIcon from "../../assets/icons/profileCross.svg";
interface PermissionsProps {
  permissions: any;
}

const Permissions: React.FC<PermissionsProps> = ({ permissions }) => {
  const modules = [
    "Objectives",
    "Initiatives",
    "Key results",
    "Milestone",
    "Role Management",
  ];

  return (
    <ul className="permissions-list">
      {modules.map((module, idx) => {
        const modulePermissions = permissions?.[module];
        const hasNoReadAccess =
          !modulePermissions || modulePermissions.read === 0;

        if (hasNoReadAccess) {
          return (
            <li key={idx + 1}>
              <img
                src={profileCrossIcon}
                alt="Denied"
                className="icon"
                style={{ marginRight: "8px" }}
              />
              {module}
            </li>
          );
        }

        const hasOnlyReadPermission =
          modulePermissions.read === 1 &&
          modulePermissions.write === 0 &&
          modulePermissions.edit === 0 &&
          modulePermissions.delete === 0;

        const label = hasOnlyReadPermission
          ? `View ${module}`
          : `Manage ${module}`;

        return (
          <li key={idx + 1}>
            <img
              src={profileCheckIcon}
              alt="Allowed"
              className="icon"
              style={{ marginRight: "8px" }}
            />
            {label}
          </li>
        );
      })}
    </ul>
  );
};

export default Permissions;
